module.exports = __webpack_public_path__ + "img/bg.ffd84e97.jpg";